/* eslint react/prop-types: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { isAuthenticated } from '../redux/auth';

const mapLoggedInProps = ({ auth, router }) => ({
    loggedIn: isAuthenticated(auth),
    search: router.location.search,
});

const guestPage = (BaseComponent) => {
    const factory = React.createFactory(BaseComponent);
    const LoginCheck = ({ loggedIn, search, ...props }) => {
        if (loggedIn) {
            const params = queryString.parse(search) || {};
            if (params.next) {
                return (<Redirect to={decodeURIComponent(params.next)} />);
            }
            return (<Redirect to="/" />);
        }
        return factory(props);
    };
    return connect(mapLoggedInProps)(LoginCheck);
};

export default guestPage;



// WEBPACK FOOTER //
// ./src/client/hoc/guestPage.js